import RichTextEditor from "./components/RichTextEditor";
import RichText from "./components/RichText";
import RichTextCard from "./components/RichTextCard";
import WirisRichText from "./components/WirisRichText";
import LazyRichTextEditor from "./components/LazyRichTextEditor";

const richtextPlugin = {
  install(app) {
    app.component("rich-text-editor", RichTextEditor);
    app.component("rich-text", RichText);
    app.component("rich-text-card", RichTextCard);
    app.component("wiris-rich-text", WirisRichText);
    app.component("lazy-rich-text-editor", LazyRichTextEditor);
  },
};

export default richtextPlugin;
